import React from 'react';

export const Pause = () =>
  <svg width="40px" height="40px" viewBox="0 0 40 40">
    <g id="pause" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#FFFFFF" x="5" y="0" width="10" height="40"></rect>
      <rect id="Rectangle-Copy" fill="#FFFFFF" x="25" y="0" width="10" height="40"></rect>
    </g>
  </svg>
;

export const Play = () =>
  <svg width="40px" height="40px" viewBox="0 0 40 40">
    <g id="play" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon id="Path-2" fill="#FFFFFF" points="0 0 0 40 40 20"></polygon>
    </g>
  </svg>
;

export const ArrowLeft = () =>
<svg width="801px" height="439px" viewBox="0 0 801 439">
  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
    <g transform="translate(-71.000000, -51.000000)" stroke="#ffffff" strokeWidth="60">
      <path d="M89.4996611,270 L88.5,270 L89.4996611,270 L291.160002,68.2712907 L89.4996611,270 Z M89.4996611,270 L854.342934,270 L89.4996611,270 L88.5,271 L89.4996611,270 Z M291.160002,471.778553 L88.5,271 L291.160002,471.778553 Z" ></path>
    </g>
  </g>
</svg>
;

export const ArrowRight = () =>
<svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="9"
    fill="none"
    viewBox="0 0 11 9"
  >
    <path
      fill="#fff"
      d="M10.354 4.854a.5.5 0 000-.708L7.172.964a.5.5 0 00-.707.708L9.293 4.5 6.465 7.328a.5.5 0 10.707.708l3.182-3.182zM.748 5H10V4H.748v1z"
    ></path>
</svg>
;

export const OneFortySix = () =>
<svg width="520px" height="301px" viewBox="0 0 520 301" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1-—-0-Start-Copy-2" transform="translate(-470.000000, -397.000000)" fill="#FDFDFD" fillRule="nonzero">
            <path d="M517.21,692 L517.21,459.6 C510.276632,466.533368 502.876706,472.66664 495.01,478 C487.143294,483.33336 478.943376,488.266644 470.41,492.8 L470.41,445.6 C480.276716,440.26664 489.87662,433.93337 499.21,426.6 C508.54338,419.26663 516.809964,411.333376 524.01,402.8 L569.21,402.8 L569.21,692 L517.21,692 Z M776.07,622.4 L776.07,692 L728.47,692 L728.47,622.4 L639.27,622.4 L639.27,579.6 L709.27,402.8 L776.07,402.8 L776.07,586 L806.07,586 L806.07,622.4 L776.07,622.4 Z M730.47,439.6 L676.07,586 L730.47,586 L730.47,439.6 Z M989.33,601.6 C989.33,616.000072 988.063346,629.066608 985.53,640.8 C982.996654,652.533392 978.663364,662.599958 972.53,671 C966.396636,679.400042 958.263384,685.866644 948.13,690.4 C937.996616,694.933356 925.330076,697.2 910.13,697.2 C894.12992,697.2 881.13005,694.86669 871.13,690.2 C861.12995,685.53331 853.263362,678.466714 847.53,669 C841.796638,659.533286 837.863344,647.733404 835.73,633.6 C833.596656,619.466596 832.53,602.800096 832.53,583.6 L832.53,522.8 C832.53,506.79992 833.263326,491.333408 834.73,476.4 C836.196674,461.466592 839.729972,448.133392 845.33,436.4 C850.930028,424.666608 859.196612,415.266702 870.13,408.2 C881.063388,401.133298 895.996572,397.6 914.93,397.6 C937.330112,397.6 954.596606,402.533284 966.73,412.4 C978.863394,422.266716 984.93,439.19988 984.93,463.2 L934.53,463.2 C934.53,454.666624 932.930016,447.466696 929.73,441.6 C926.529984,435.733304 920.396712,432.8 911.33,432.8 C904.129964,432.8 898.53002,435.79997 894.53,441.8 C890.52998,447.80003 887.596676,455.333288 885.73,464.4 C883.863324,473.466712 882.730002,483.533278 882.33,494.6 C881.929998,505.666722 881.73,516.133284 881.73,526 L881.73,532.8 C886.796692,526.666636 892.729966,521.400022 899.53,517 C906.330034,512.599978 915.863272,510.4 928.13,510.4 C940.13006,510.4 950.063294,512.39998 957.93,516.4 C965.796706,520.40002 972.06331,526.266628 976.73,534 C981.39669,541.733372 984.663324,551.26661 986.53,562.6 C988.396676,573.93339 989.33,586.93326 989.33,601.6 Z M938.53,601.6 C938.53,593.066624 938.263336,585.266702 937.73,578.2 C937.196664,571.133298 935.996676,565.133358 934.13,560.2 C932.263324,555.266642 929.463352,551.46668 925.73,548.8 C921.996648,546.13332 916.930032,544.8 910.53,544.8 C903.8633,544.8 898.596686,546.733314 894.73,550.6 C890.863314,554.466686 887.996676,559.199972 886.13,564.8 C884.263324,570.400028 883.130002,576.466634 882.73,583 C882.329998,589.533366 882.13,595.599972 882.13,601.2 C882.13,610.000044 882.46333,618.133296 883.13,625.6 C883.79667,633.066704 885.12999,639.533306 887.13,645 C889.13001,650.466694 891.996648,654.666652 895.73,657.6 C899.463352,660.533348 904.263304,662 910.13,662 C916.7967,662 922.063314,660.400016 925.93,657.2 C929.796686,653.999984 932.663324,649.600028 934.53,644 C936.396676,638.399972 937.529998,631.93337 937.93,624.6 C938.330002,617.26663 938.53,609.60004 938.53,601.6 Z" id="146"></path>
        </g>
    </g>
</svg>;

export const SelectArrowDown = () =>
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="6"
  height="8"
  fill="none"
  viewBox="0 0 6 8"
  >
    <path
    fill="#011534"
    d="M2.717 7.283a.4.4 0 00.566 0l2.545-2.546a.4.4 0 00-.565-.565L3 6.434.737 4.172a.4.4 0 10-.565.565l2.545 2.546zM2.6 0v7h.8V0h-.8z"
    ></path>
</svg>;


export const Fullscreen = () =>
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="14"
  viewBox="0 0 20 14"
>
  <g fill="none" fillRule="evenodd" stroke="#ffffff" strokeWidth="1">
    <path d="M4 1L1 1 1 13.0917094 4 13.0917094"></path>
    <path d="M16 1L19 1 19 13.0917094 16 13.0917094"></path>
  </g>
</svg>;

export const Unfullscreen = () =>
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="14"
  viewBox="0 0 20 14"
>
  <g fill="none" fillRule="evenodd" stroke="#ffffff" strokeWidth="1">
    <g transform="translate(.5 6.9)">
      <path d="M0 6.625L7.5 1.414"></path>
      <path
        d="M3.3 1L7.3 1 7.3 5.00135295"
        transform="rotate(10 5.3 3)"
      ></path>
    </g>
    <g transform="rotate(-180 9.75 3.6)">
      <path d="M0 6.625L7.5 1.414"></path>
      <path
        d="M3.3 1L7.3 1 7.3 5.00135295"
        transform="rotate(10 5.3 3)"
      ></path>
    </g>
  </g>
</svg>;
